import React from "react";

import { getFirestoreData, updateFirestoreWithOneObject } from 'store/actions/firestoreActions.jsx'
import { startSetUser, updateUser } from 'store/actions/profileActions.jsx'
import moment from "moment"
import { db, firebase } from "firebase/fbConfig.js"
import Button from "components/CustomButtons/Button.jsx";

// Get Users for Users Panel
export const startSetOrdersList = (id) => {
  console.log(id)
  return (dispatch) => {
    db.collection("haney-orders").where('vendorPickUpID', '==', id)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          // console.log(docData.pickUpDate)
          if (!docData.test) {

            var docObj = {
              id: doc.id,
              freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
              uid: docData.uid ? docData.uid : "N/A",
              origin: docData.origin ? docData.origin.businessName : "N/A",
              originLocation: docData.origin ? `${docData.origin.city}/${docData.origin.state}` : "N/A",
              pickUpDate: docData.origin ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
              destination: docData.destination ? docData.destination.businessName : "N/A",
              destinationLocation: docData.destination ? `${docData.destination.city}/${docData.destination.state}` : "N/A",
              dropOffDate: docData.destination ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
              // class: docData.class ? docData.class : "N/A",
              status: docData.status ? ((docData.status == "Pending" || docData.status == "pending") ? "Pending" : ((docData.status == "Quoted Needs Approval" || docData.status == "quoted" || docData.status === 'Quoted') ? "Quoted" : ((docData.status == "Booked" || docData.status == "booked") ? "Booked" : ((docData.status == "Dispatched" || docData.status == "dispatched" || docData.status == "In Route to Shipper" || docData.status == "Arrived at Shipper") ? "Dispatched" : (docData.status == "In Transit" || docData.status == "Driver Departed Shipper" || docData.status == "Arrived at Airline" || docData.status == "Tendered to Airline Awaiting Departure" || docData.status == "Aircraft In Route to Origin" || docData.status == "Aircraft Arrived at Origin" || docData.status == "Wheels Up" || docData.status == "Wheels Down" || docData.status == "Aircraft Download" || docData.status == "In Route to Consignee" || docData.status == "Arrived at Consignee" || docData.status == "Driver Departed Consignee" || docData.status == "Arrived At Destination") ? "In-Transit" : ((docData.status == "delivered") || (docData.status == "Delivered") ? "Delivered" : ((docData.status == "cancelled") || (docData.status == "canceled") || (docData.status == "Canceled")) ? "Canceled" : (docData.status)))))) : "N/A",
            }
            console.log(docObj)
            data.push(docObj);
          }
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        db.collection("haney-orders").where('vendorDropOffID', '==', id)
          .get().then((snapshot) => {
            const newData = data
            // Parse data into array like in firebase.js
            snapshot.forEach((doc) => {
              var docData = doc.data()
              // console.log(docData.pickUpDate)
              if (!docData.test) {

                var docObj = {
                  id: doc.id,
                  freightBillNumber: docData.freightBillNumber ? docData.freightBillNumber : "N/A",
                  uid: docData.uid ? docData.uid : "N/A",
                  origin: docData.origin ? docData.origin.businessName : "N/A",
                  originLocation: docData.origin ? `${docData.origin.city}/${docData.origin.state}` : "N/A",
                  pickUpDate: docData.origin ? moment(docData.origin.date.toDate()).format('MM/DD/YYYY') : "N/A",
                  destination: docData.destination ? docData.destination.businessName : "N/A",
                  destinationLocation: docData.destination ? `${docData.destination.city}/${docData.destination.state}` : "N/A",
                  dropOffDate: docData.destination ? moment(docData.destination.date.toDate()).format('MM/DD/YYYY') : "N/A",
                  // class: docData.class ? docData.class : "N/A",
                  status: docData.status ? ((docData.status == "Pending" || docData.status == "pending") ? "Pending" : ((docData.status == "Quoted Needs Approval" || docData.status == "quoted" || docData.status === 'Quoted') ? "Quoted" : ((docData.status == "Booked" || docData.status == "booked") ? "Booked" : ((docData.status == "Dispatched" || docData.status == "dispatched" || docData.status == "In Route to Shipper" || docData.status == "Arrived at Shipper") ? "Dispatched" : (docData.status == "In Transit" || docData.status == "Driver Departed Shipper" || docData.status == "Arrived at Airline" || docData.status == "Tendered to Airline Awaiting Departure" || docData.status == "Aircraft In Route to Origin" || docData.status == "Aircraft Arrived at Origin" || docData.status == "Wheels Up" || docData.status == "Wheels Down" || docData.status == "Aircraft Download" || docData.status == "In Route to Consignee" || docData.status == "Arrived at Consignee" || docData.status == "Driver Departed Consignee" || docData.status == "Arrived At Destination") ? "In-Transit" : ((docData.status == "delivered") || (docData.status == "Delivered") ? "Delivered" : ((docData.status == "cancelled") || (docData.status == "canceled") || (docData.status == "Canceled")) ? "Canceled" : (docData.status)))))) : "N/A",
                }
                console.log(docObj)
                newData.push(docObj);
              }
            })
            return (newData)
          }, (error) => {
            console.log('error fetching data: ', error)
          }).then(newData => {
            console.log(newData)
            dispatch(setOrdersList(newData))
          })
      })
  }
}

export const startSetPendingOrdersList = (status) => {
  return (dispatch) => {
    db.collection("haney-orders").where("status", "==", "pending")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.originZip ? docData.originZip : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destinationZip ? docData.destinationZip : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
            status: docData.status ? docData.status : "N/A",
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setPendingOrdersList(data))
      })
  }
}

export const startSetBookedOrdersList = (status) => {
  return (dispatch) => {
    db.collection("haney-orders").where("status", "==", "booked")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.originZip ? docData.originZip : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destinationZip ? docData.destinationZip : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setBookedOrdersList(data))
      })
  }
}


export const startSetDispatchedOrdersList = (status) => {
  return (dispatch) => {
    db.collection("haney-orders").where("status", "==", "dispatched")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.originZip ? docData.originZip : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destinationZip ? docData.destinationZip : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
          }
          data.push(docObj);
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setDispatchedOrdersList(data))
      })
  }
}

export const startSetDriverDispatchedOrdersList = (uid) => {
  return (dispatch) => {
    db.collection("orders").where("status", "==", "dispatched").where('pickUpCarrier', '==', uid)
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            shippingMode: docData.shippingMode ? docData.shippingMode : "N/A",
            origin: docData.origin ? docData.origin : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destination ? docData.destination : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setDispatchedOrdersList(data))
      })
  }
}


export const startSetConfirmedOrdersList = (status) => {
  return (dispatch) => {
    db.collection("haney-orders").where("status", "==", "completed")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.originZip ? docData.originZip : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destinationZip ? docData.destinationZip : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
            updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
          }
          data.push(docObj);
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setConfirmedOrdersList(data))
      })
  }
}

export const startSetFavoritedOrdersList = (uid) => {
  return (dispatch) => {
    db.collection("TEST-users").doc(uid).collection("favoritedOrders")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.pickUpDate)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.originZip ? docData.originZip : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destinationZip ? docData.destinationZip : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
            updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
          }
          data.push(docObj);
        })
        console.log(data)
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setFavoritedOrdersList(data))
      })
  }
}



export const startSetMyOrdersList = (uid) => {
  return (dispatch) => {
    db.collection("TEST-users").doc(uid).collection("orders")
      .get().then((snapshot) => {
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          console.log(docData.status)
          var docObj = {
            id: doc.id,
            uid: docData.uid ? docData.uid : "N/A",
            deliveryType: docData.deliveryType ? docData.deliveryType : "N/A",
            origin: docData.originZip ? docData.originZip : "N/A",
            pickUpDate: docData.pickUpDate ? moment(docData.pickUpDate.toDate()).format('MM/DD/YYYY') : "N/A",
            destination: docData.destinationZip ? docData.destinationZip : "N/A",
            dropOffDate: docData.dropOffDate ? moment(docData.dropOffDate.toDate()).format('MM/DD/YYYY') : "N/A",
            class: docData.class ? docData.class : "N/A",
            submitted: docData.submitted ? moment(docData.submitted.toDate()).format('MM/DD/YYYY') : "N/A",
            status: docData.status ? docData.status : "N/A",
            updatedAt: docData.updatedAt ? moment(docData.updatedAt.toDate()).format('MM/DD/YYYY HH:SS') : "N/A",
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        dispatch(setOrdersList(data))
      })
  }
}

export const setOrdersList = (dataRows) => ({
  type: 'SET_ORDERS_LIST',
  dataRows
})


export const setPendingOrdersList = (dataRows) => ({
  type: 'SET_PENDING_ORDERS_LIST',
  dataRows
})

export const setBookedOrdersList = (dataRows) => ({
  type: 'SET_BOOKED_ORDERS_LIST',
  dataRows
})

export const setDispatchedOrdersList = (dataRows) => ({
  type: 'SET_DISPATCHED_ORDERS_LIST',
  dataRows
})
export const setConfirmedOrdersList = (dataRows) => ({
  type: 'SET_CONFIRMED_ORDERS_LIST',
  dataRows
})

export const setFavoritedOrdersList = (dataRows) => ({
  type: 'SET_FAVORITED_ORDERS_LIST',
  dataRows
})

startSetBookedOrdersList


// WEBPACK FOOTER //
// ./src/store/actions/ordersActions.jsx